import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import usePageTitle from "../hooks/usePageTitle";

/** 404 — страница не найдена. */
export default function NotFoundPage() {
  usePageTitle("Страница не найдена");
  return (
    <Layout>
      <section className="rb-section" style={{ textAlign: "center" }}>
        <div className="rb-container">
          <div
            style={{
              fontSize: 88,
              fontWeight: 800,
              color: "var(--rb-accent)",
              lineHeight: 1,
            }}
          >
            404
          </div>
          <h1 className="rb-section__title">Страница не найдена</h1>
          <p className="rb-section__subtitle">
            Возможно, ссылка устарела или была введена с ошибкой.
          </p>
          <Link to="/" className="rb-btn rb-btn--primary rb-btn--lg">
            На главную
          </Link>
        </div>
      </section>
    </Layout>
  );
}
